export default "__VITE_ASSET__DdR56Qli__"